import { render, staticRenderFns } from "./BtnImagenes.vue?vue&type=template&id=52243074&scoped=true"
import script from "./BtnImagenes.vue?vue&type=script&lang=js"
export * from "./BtnImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52243074",
  null
  
)

export default component.exports